import { render } from "./DismantlingTask.vue?vue&type=template&id=04bd938a&scoped=true&ts=true&lang=pug"
import script from "./DismantlingTask.vue?vue&type=script&lang=ts"
export * from "./DismantlingTask.vue?vue&type=script&lang=ts"

import "./DismantlingTask.vue?vue&type=style&index=0&id=04bd938a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bd938a"]])

export default __exports__